import { ReactNode } from 'react';

interface PageShellProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

function PageShell({ title, subtitle, children }: PageShellProps) {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-white">{title}</h2>
        {subtitle && <p className="mt-1 text-sm text-zt-muted">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}

export default PageShell;
